import { Component } from '@angular/core';

@Component({
    selector: 'mh-smart-replies',
    templateUrl: './smart-replies.component.html',
    standalone: false
})
export class SmartRepliesComponent {}
